// extracted by mini-css-extract-plugin
export default {"wrapper":"_zElSZaqd6E1I3KLp8yE","smallButton":"MD_Cipepa9G_yviI1efp"};